module.exports = __webpack_public_path__ + "media/images/alizza-c72f62d4464370a2f0b4ee0f7f3888cc.png";